/**
 * This utility is used to log/debug only on development environment.
 * It is silent in production.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LogFunction = (message: string, ...optionalParams: any[]) => void;

interface Logger {
    log: LogFunction;
    warn: LogFunction;
    error: LogFunction;
}

const logger: Logger = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    log: (message: string, ...optionalParams: any[]): void => {
        if (process.env.NODE_ENV === 'development') {
            console.log(message, ...optionalParams);
        }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    warn: (message: string, ...optionalParams: any[]): void => {
        if (process.env.NODE_ENV === 'development') {
            console.warn(message, ...optionalParams);
        }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: (message: string, ...optionalParams: any[]): void => {
        if (process.env.NODE_ENV === 'development') {
            console.error(message, ...optionalParams);
        }
    },
};

export default logger;
